export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-bold mb-6">
              Foreclosure Help in El Paso, Texas
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6 leading-tight">
              You Don't Have to Face Foreclosure Alone
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              If you're behind on mortgage payments and facing foreclosure in El Paso, Texas, time is critical. Every day that passes brings you closer to losing your home and damaging your credit score for years to come. But there's a solution that can help you avoid foreclosure now and move forward with your life.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At TRex RE LLC - The Texas Property buyers, we specialize in buying foreclosed properties and homes at risk of foreclosure throughout El Paso and surrounding areas. We've helped hundreds of homeowners avoid foreclosure by purchasing their properties quickly for cash, allowing them to walk away with money in their pocket and their dignity intact. Whether you're also dealing with <a href="/title-issues" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">title issues</a> or own a <a href="/sell-distressed-property" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">distressed property</a>, we can help.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Unlike traditional real estate sales that can take months, we can close in as little as 7 days. We buy houses in any condition, handle all the paperwork, and work directly with your lender to ensure a smooth transaction. You don't need to make repairs, pay realtor commissions, or wait for buyer financing to fall through. Learn more about our <a href="/elpaso-tx" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso home buying services</a> and stay updated with <a href="/local-news-el-paso-texas" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">local real estate news</a>.
            </p>
            <div className="bg-gray-50 border-l-4 border-teal-600 p-6 rounded-lg">
              <p className="text-base text-gray-800 font-semibold mb-2">
                <i className="ri-information-fill text-teal-600 mr-2"></i>
                Did You Know?
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                In Texas, the foreclosure process can be completed in as little as 41 days from the first notice. That's why acting quickly to avoid foreclosure is essential. We can make you a cash offer within 24 hours and close before the foreclosure sale date.
              </p>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/ac0f54b92052a273f82366e0e7965d31.jpg" 
              alt="We help homeowners avoid foreclosure in El Paso" 
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-8 rounded-xl shadow-2xl max-w-xs">
              <div className="text-5xl font-black mb-2">500+</div>
              <p className="text-base font-semibold">Homeowners Helped Avoid Foreclosure in El Paso</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}